import React from "react";
import { cn } from "../../lib/utils";

export function DashboardTabs({
  items,
  activeKey,
  onChange,
  className,
  variant = "primary",
}) {
  const isSecondary = variant === "secondary";

  return (
    <div
      role="tablist"
      className={cn(
        "max-w-full overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
        isSecondary
          ? "inline-flex items-center gap-1 border-b border-white/5 px-1"
          : "inline-flex items-center gap-1 rounded-xl border border-white/10 bg-[#0a0a0a]/70 p-1 backdrop-blur-sm",
        className
      )}
    >
      {items.map((item) => {
        const isActive = activeKey === item.key;
        const Icon = item.Icon;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(item.key)}
            className={cn(
              "inline-flex flex-shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium transition-colors",
              "focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400/60",
              isSecondary
                ? cn(
                    "relative px-3 py-2.5 -mb-px border-b-2",
                    isActive
                      ? "border-violet-400 text-violet-100"
                      : "border-transparent text-gray-400 hover:text-gray-100"
                  )
                : cn(
                    "rounded-lg px-3.5 py-2",
                    isActive
                      ? "bg-violet-500/20 text-violet-100 shadow-[0_0_0_1px_rgba(167,139,250,0.35)]"
                      : "text-gray-400 hover:bg-white/5 hover:text-gray-100"
                  )
            )}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export default DashboardTabs;
